import { Alert, Center } from '@chakra-ui/react';
import { sentryReact } from '../lib/sentryReact';
import { Component } from 'react';
import { NotFound } from '@duke-hq/ui/components/NotFound/NotFound';

export class ErrorBoundary extends Component<
  {
    children: React.ReactNode;
  },
  {
    error: Error | null;
  }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch() {
    sentryReact.captureException(this.state.error);
  }

  override render() {
    if (this.state.error?.message === 'No UnitAssessment found') {
      return <NotFound />;
    }
    if (this.state.error) {
      return (
        <Center h="100vh">
          <Alert status="error">{this.state.error.stack ?? 'Something went wrong.'}</Alert>
        </Center>
      );
    }

    return this.props.children;
  }
}
